@for (alert of alerts; track alert) {
  <cap-bsg-alert [type]="alert.type" (dismiss)="dismiss(alert)">
    {{ alert.message }}
    @if (alert.type === capAlertTypeDanger) {
      <button (click)="copyStackToClipboard(alert)" class="alert-danger, alert-button">Copy Details</button>
      <button (click)="reportError(alert)" class="alert-button">Report</button>
    }
    @if (alert.additionalInfoLink) {
      <a [href]="alert.additionalInfoLink" class="alert-link" target="_blank">{{ translate.instant('inbox.open') }}</a>
    }
  </cap-bsg-alert>
}
